import React, { Component } from 'react';
import PropTypes from 'prop-types';
import whiteBackground from '../wrapper-components/white-background';
import AttendeeAddDetailsPageBody from './AttendeeAddDetailsPageBody';
import { NotificationBanner } from '../elements-banner/notification-banner';
import ReduxBanner from '../elements-banner/ReduxBanner';
import { toggleBanner } from '../app-main/actions/banner';
import _ from 'lodash';
import { push } from 'react-router-redux';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';

class AttendeeAddDetailsPageBooking extends Component {
  constructor (props) {
    super(props);

    this.redirectToSendInvite = this.redirectToSendInvite.bind(this);
  }

  componentDidMount () {
    this.props.dispatch(toggleBanner('attendeePageBanner'));
  }

  redirectToSendInvite () {
    const bookingId = _.get(this.props, 'booking.booking._id');
    this.props.dispatch(push(`/invite/send/${bookingId}/booking`));
  }

  render () {
    return (
      <div className="AttendeeAddDetailsPageBooking style-2 flex center">
        <ReduxBanner>
          <NotificationBanner
            showClose
            bannerId="attendeePageBanner"
            message={(
              <span className="text-center">
                <i className="ico icon-yes margin-sm-right" />
                &nbsp;
                <FormattedMessage id='invite.attendee_add_details_page_booking.confirmed' defaultMessage='Your booking is confirmed.' />
              </span>
            )}
          />
        </ReduxBanner>
        <div className="content-container">
          <div>
            <h2>
              <FormattedMessage id='invite.attendee_add_details_page_booking.who_else' defaultMessage='Who else is coming?' />
            </h2>

            <h3>
              <span>
                <FormattedMessage id='invite.attendee_add_details_page_booking.details' defaultMessage='Details' />
              </span>
              &nbsp;
              <i className="ico ico-sm icon-arrow-nav icon-rotate-270 arrow-title-spacing" />
              &nbsp;
              <span className="text-gray">
                <FormattedMessage id='invite.attendee_add_details_page_booking.send_invite' defaultMessage='Send Invite' />
              </span>
            </h3>
          </div>

          <AttendeeAddDetailsPageBody
            {...this.props}
            pageType="add_details_booking"
            submitRedirect={this.redirectToSendInvite}
            submitButtonText={ this.props.intl.formatMessage({ id: 'invite.attendee_add_details_page_booking.save_continue', defaultMessage: 'Save and Continue' }) }
            showSkip
          />
        </div>
      </div>
    );
  }
}

AttendeeAddDetailsPageBooking.propTypes = {
  dispatch: PropTypes.func,
  intl: intlShape
};

const mapStateToProps = ({ booking }) => ({ booking });

export default injectIntl(connect(mapStateToProps)(whiteBackground(AttendeeAddDetailsPageBooking)));
